import { useEffect } from 'react';
import { useNav } from '@/lib/nav';
import routes from '@/lib/routes';

export default function BillingCancel() {
  const { go } = useNav();

  useEffect(() => {
    const t = setTimeout(() => go(routes.dashboard() + '?billing=cancel'), 1500);
    return () => clearTimeout(t);
  }, [go]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center space-y-2">
        <h1 className="text-xl font-semibold">Checkout canceled</h1>
        <p className="text-muted-foreground">You can retry anytime from the app.</p>
      </div>
    </div>
  );
}


